export const ChartConfig = {
  color: {
    primary: "#5D92F4",
    warning: "#FFB70F",
    danger: "#FF3739",
    success: "#00D014",
    info: "#00D0BD",
    white: "#fff",
    lightGrey: "#E8ECEE",
    grey: "#848484"
  },
  lineChartAxesColor: "#E9ECEF",
  legendFontColor: "#AAAEB3",
  chartGridColor: "#EAEAEA",
  axesColor: "#657786",
  fontSize: 16,
  padding: 40,
  fontFamily: "Montserrat",
  fontColor: "#c3c5cd",
  shadowColor: "rgba(0,0,0,0.3)"
};
